import {FJAnimationSlotStore} from "fj-graph";

export default (function () {
  const ANIMATION_NAME = FJAnimationSlotStore.allAnimationType();
  const _animationInData = [
    {
      category: "Enter Animation",
      list: [
        {name: "None"},
      ]
    },
    {
      category: "Fading Entrances",
      list: [
        {path: "/enter/fade_in.svg", name: "Fade In"},
        {path: "/enter/fade_in_down.svg", name: "Fade In Down"},
        {path: "/enter/fade_in_up.svg", name: "Fade In Up"},
        {path: "/enter/fade_in_left.svg", name: "Fade In Left"},
        {path: "/enter/fade_in_right.svg", name: "Fade In Right"}
      ]
    },
    {
      category: "Enter",
      list: [
        {path: "/enter/enter_left.svg", name: "Enter Left"},
        {path: "/enter/enter_right.svg", name: "Enter Right"},
        {path: "/enter/enter_top.svg", name: "Enter Top"},
        {path: "/enter/enter_bottom.svg", name: "Enter Bottom"},

        {path: "/enter/enter_left_top.svg", name: "Enter Left Top"},
        {path: "/enter/enter_left_bottom.svg", name: "Enter Left Bottom"},
        {path: "/enter/enter_right_top.svg", name: "Enter Right Top"},
        {path: "/enter/enter_right_bottom.svg", name: "Enter Right Bottom"},
      ]
    },
    {
      category: "Popup",
      list: [
        {path: "/enter/popup_center.svg", name: "Popup Center"},
        {path: "/enter/popup_left.svg", name: "Popup Left"},
        {path: "/enter/popup_right.svg", name: "Popup Right"},
        {path: "/enter/popup_bottom.svg", name: "Popup Bottom"},
        {path: "/enter/popup_top.svg", name: "Popup Top"},
        {path: "/enter/popup_top_left.svg", name: "Popup Top Left"},
        {path: "/enter/popup_top_right.svg", name: "Popup Bottom Left"},
        {path: "/enter/popup_bottom_left.svg", name: "Popup Top Right"},
        {path: "/enter/popup_bottom_right.svg", name: "Popup Bottom Right"}
      ]
    },
    {
      category: "Wipe",
      list: [
        {path: "/enter/wipe_top.svg", name: "Wipe Top"},
        {path: "/enter/wipe_bottom.svg", name: "Wipe Bottom"},
        {path: "/enter/wipe_left.svg", name: "Wipe Left"},
        {path: "/enter/wipe_right.svg", name: "Wipe Right"}
      ]
    },
    {
      category: "Rotate",
      list: [
        {path: "/enter/rotate_clockwise.svg", name: "Rotate Clockwise"},
        {path: "/enter/rotate_anticlockwise.svg", name: "Rotate Anticlockwise"},
        {path: "/enter/rotate_popup_clockwise.svg", name: "Rotate Popup Clockwise"},
        {path: "/enter/rotate_popup_anticlockwise.svg", name: "Rotate Popup Anticlockwise"},
      ]
    },
    {
      category: "Flip",
      list: [
        {path: "/enter/flip_in_x.svg", name: "Flip In X"},
        {path: "/enter/flip_in_y.svg", name: "Flip In Y"},
      ]
    },
    {
      category: "Zoom In Center",
      list: [
        {path: "/enter/zoom_in.svg", name: "Zoom In"},
        {path: "/enter/zoom_in_down.svg", name: "Zoom In Down"},
        {path: "/enter/zoom_in_up.svg", name: "Zoom In Up"},
        {path: "/enter/zoom_in_left.svg", name: "Zoom In Left"},
        {path: "/enter/zoom_in_right.svg", name: "Zoom In Right"}
      ]
    },
    {
      category: "Special",
      list: [
        {path: "/enter/bounce_in.svg", name: "Bounce In"},
        {path: "/enter/flash.svg", name: "Flash"}
      ]
    },
  ];
  const _animationOutData = [
    {
      category: "Exit Animation",
      list: [
        {name: "None"},
      ]
    },
    {
      category: "Fading Out",
      list: [
        {path: "/exit/fade_out.svg", name: "Fade Out"},
        {path: "/exit/fade_out_down.svg", name: "Fade Out Down"},
        {path: "/exit/fade_out_up.svg", name: "Fade Out Up"},
        {path: "/exit/fade_out_left.svg", name: "Fade Out Left"},
        {path: "/exit/fade_out_right.svg", name: "Fade Out Right"}
      ]
    },
    {
      category: "Out",
      list: [
        {path: "/exit/out_left.svg", name: "Out Left"},
        {path: "/exit/out_right.svg", name: "Out Right"},
        {path: "/exit/out_bottom.svg", name: "Out Bottom"},
        {path: "/exit/out_top.svg", name: "Out Top"},
        {path: "/exit/out_right_top.svg", name: "Out Left Top"},
        {path: "/exit/out_right_bottom.svg", name: "Out Left Bottom"},
        {path: "/exit/out_left_top.svg", name: "Out Right Top"},
        {path: "/exit/out_left_bottom.svg", name: "Out Right Bottom"},
      ]
    },
    {
      category: "Popup",
      list: [
        {path: "/exit/popdown_center.svg", name: "Popdown Center"},
        {path: "/exit/popdown_left.svg", name: "Popdown Left"},
        {path: "/exit/popdown_right.svg", name: "Popdown Right"},
        {path: "/exit/popdown_bottom.svg", name: "Popdown Bottom"},
        {path: "/exit/popdown_top.svg", name: "Popdown Top"},
        {path: "/exit/popdown_top_left.svg", name: "Popdown Top Left"},
        {path: "/exit/popdown_top_right.svg", name: "Popdown Bottom Left"},
        {path: "/exit/popdown_bottom_left.svg", name: "Popdown Top Right"},
        {path: "/exit/popdown_bottom_right.svg", name: "Popdown Bottom Right"}
      ]
    },
    {
      category: "Wipe",
      list: [
        {path: "/exit/wipe_bottom_out.svg", name: "Wipe Out Bottom"},
        {path: "/exit/wipe_top_out.svg", name: "Wipe Out Top"},
        {path: "/exit/wipe_left_out.svg", name: "Wipe Out Left"},
        {path: "/exit/wipe_right_out.svg", name: "Wipe Out Right"}
      ]
    },
    {
      category: "Rotate",
      list: [
        {path: "/exit/rotate_zoom_out_clockwise.svg", name: "Rotate Zoom Out Clockwise"},
        {path: "/exit/rotate_zoom_out_anticlockwise.svg", name: "Rotate Zoom Out Anticlockwise"},
        {path: "/exit/rotate_zoom_out_popup_clockwise.svg", name: "Rotate Zoom Out Popup Clockwise"},
        {path: "/exit/rotate_zoom_out_popup_anticlockwise.svg", name: "Rotate Zoom Out Popup Anticlockwise"}
      ]
    },
    {
      category: "Flip",
      list: [
        {path: "/exit/flip_out_x.svg", name: "Flip Out X"},
        {path: "/exit/flip_out_y.svg", name: "Flip Out Y"},
      ]
    },
    {
      category: "Zoom Out",
      list: [
        {path: "/exit/zoom_out.svg", name: "Zoom Out Center"},
        {path: "/exit/zoom_out_down.svg", name: "Zoom Out Down"},
        {path: "/exit/zoom_out_up.svg", name: "Zoom Out Up"},
        {path: "/exit/zoom_out_right.svg", name: "Zoom Out Left"},
        {path: "/exit/zoom_out_left.svg", name: "Zoom Out Right"},
      ]
    },
  ];
  const _animationMap = {
    "Fade In": ANIMATION_NAME.FADE_IN,
    "Fade In Down": ANIMATION_NAME.FADE_IN_DOWN,
    "Fade In Up": ANIMATION_NAME.FADE_IN_UP,
    "Fade In Left": ANIMATION_NAME.FADE_IN_LEFT,
    "Fade In Right": ANIMATION_NAME.FADE_IN_RIGHT,
    "Enter Left": ANIMATION_NAME.MOVE_IN_LEFT,
    "Enter Right": ANIMATION_NAME.MOVE_IN_RIGHT,
    "Enter Top": ANIMATION_NAME.MOVE_IN_UP,
    "Enter Bottom": ANIMATION_NAME.MOVE_IN_BOTTOM,
    "Enter Left Top": ANIMATION_NAME.MOVE_IN_LEFT_UP,
    "Enter Left Bottom": ANIMATION_NAME.MOVE_IN_LEFT_BOTTOM,
    "Enter Right Top": ANIMATION_NAME.MOVE_IN_RIGHT_UP,
    "Enter Right Bottom": ANIMATION_NAME.MOVE_IN_RIGHT_BOTTOM,
    "Popup Center": ANIMATION_NAME.POPUP_IN,
    "Popup Left": ANIMATION_NAME.POPUP_IN_LEFT,
    "Popup Right": ANIMATION_NAME.POPUP_IN_RIGHT,
    "Popup Top": ANIMATION_NAME.POPUP_IN_UP,
    "Popup Bottom": ANIMATION_NAME.POPUP_IN_DOWN,
    "Popup Bottom Right": ANIMATION_NAME.POPUP_IN_RIGHT_DOWN,
    "Popup Bottom Left": ANIMATION_NAME.POPUP_IN_LEFT_DOWN,
    "Popup Top Left": ANIMATION_NAME.POPUP_IN_LEFT_UP,
    "Popup Top Right": ANIMATION_NAME.POPUP_IN_RIGHT_UP,
    "Wipe Top": ANIMATION_NAME.WIPE_IN_UP,
    "Wipe Bottom": ANIMATION_NAME.WIPE_IN_BOTTOM,
    "Wipe Right": ANIMATION_NAME.WIPE_IN_RIGHT,
    "Wipe Left": ANIMATION_NAME.WIPE_IN_LEFT,
    "Rotate Clockwise": ANIMATION_NAME.ROTATE_IN_CLOCKWISE,
    "Rotate Anticlockwise": ANIMATION_NAME.ROTATE_IN_ANTIC_CLOCKWISE,
    "Rotate Popup Clockwise": ANIMATION_NAME.ROTATE_POPUP_IN_CLOCKWISE,
    "Rotate Popup Anticlockwise": ANIMATION_NAME.ROTATE_POPUP_IN_ANTIC_CLOCKWISE,
    "Flip In X": ANIMATION_NAME.FLIP_IN_X,
    "Flip In Y": ANIMATION_NAME.FLIP_IN_Y,
    "Zoom In": ANIMATION_NAME.ZOOM_IN,
    "Zoom In Down": ANIMATION_NAME.ZOOM_IN_DOWN,
    "Zoom In Left": ANIMATION_NAME.ZOOM_IN_LEFT,
    "Zoom In Right": ANIMATION_NAME.ZOOM_IN_RIGHT,
    "Zoom In Up": ANIMATION_NAME.ZOOM_IN_UP,
    "Bounce In": ANIMATION_NAME.BOUNCE_IN,
    "Flash": ANIMATION_NAME.FLASH,
    "Fade Out": ANIMATION_NAME.FADE_OUT,
    "Fade Out Down": ANIMATION_NAME.FADE_OUT_DOWN,
    "Fade Out Left": ANIMATION_NAME.FADE_OUT_LEFT,
    "Fade Out Right": ANIMATION_NAME.FADE_OUT_RIGHT,
    "Fade Out Up": ANIMATION_NAME.FADE_OUT_UP,
    "Out Left": ANIMATION_NAME.MOVE_OUT_LEFT,
    "Out Right": ANIMATION_NAME.MOVE_OUT_RIGHT,
    "Out Top": ANIMATION_NAME.MOVE_OUT_UP,
    "Out Bottom": ANIMATION_NAME.MOVE_OUT_BOTTOM,
    "Out Left Top": ANIMATION_NAME.MOVE_OUT_LEFT_UP,
    "Out Left Bottom": ANIMATION_NAME.MOVE_OUT_LEFT_BOTTOM,
    "Out Right Top": ANIMATION_NAME.MOVE_OUT_RIGHT_UP,
    "Out Right Bottom": ANIMATION_NAME.MOVE_OUT_RIGHT_BOTTOM,
    "Popdown Center": ANIMATION_NAME.POPUP_OUT,
    "Popdown Left": ANIMATION_NAME.POPUP_OUT_LEFT,
    "Popdown Right": ANIMATION_NAME.POPUP_OUT_RIGHT,
    "Popdown Top": ANIMATION_NAME.POPUP_OUT_UP,
    "Popdown Bottom": ANIMATION_NAME.POPUP_OUT_DOWN,
    "Popdown Bottom Right": ANIMATION_NAME.POPUP_OUT_RIGHT_DOWN,
    "Popdown Bottom Left": ANIMATION_NAME.POPUP_OUT_LEFT_DOWN,
    "Popdown Top Left": ANIMATION_NAME.POPUP_OUT_LEFT_UP,
    "Popdown Top Right": ANIMATION_NAME.POPUP_OUT_RIGHT_UP,
    "Wipe Out Top": ANIMATION_NAME.WIPE_OUT_UP,
    "Wipe Out Bottom": ANIMATION_NAME.WIPE_OUT_BOTTOM,
    "Wipe Out Right": ANIMATION_NAME.WIPE_OUT_RIGHT,
    "Wipe Out Left": ANIMATION_NAME.WIPE_OUT_LEFT,
    "Rotate Zoom Out Clockwise": ANIMATION_NAME.ROTATE_OUT_CLOCKWISE,
    "Rotate Zoom Out Anticlockwise": ANIMATION_NAME.ROTATE_OUT_ANTIC_CLOCKWISE,
    "Rotate Zoom Out Popup Anticlockwise": ANIMATION_NAME.ROTATE_POPUP_OUT_CLOCKWISE,
    "Rotate Zoom Out Popup Clockwise": ANIMATION_NAME.ROTATE_POPUP_OUT_ANTIC_CLOCKWISE,
    "Flip Out X": ANIMATION_NAME.FLIP_OUT_X,
    "Flip Out Y": ANIMATION_NAME.FLIP_OUT_Y,
    "Zoom Out Center": ANIMATION_NAME.ZOOM_OUT,
    "Zoom Out Down": ANIMATION_NAME.ZOOM_OUT_DOWN,
    "Zoom Out Up": ANIMATION_NAME.ZOOM_OUT_UP,
    "Zoom Out Left": ANIMATION_NAME.ZOOM_OUT_LEFT,
    "Zoom Out Right": ANIMATION_NAME.ZOOM_OUT_RIGHT
  };
  return {

    /**
     * @description 返回入场数据
     * @return {Array}
     */
    get animationInData() {
      return _animationInData;
    },

    /**
     * @description 返回出场数据
     * @return {Array}
     */
    get animationOutData() {
      return _animationOutData;
    },

    /**
     * @description 返回入场/出场类型映射
     * @return {Object}
     */
    get animationMap() {
      return _animationMap;
    },

    /**
     * @description 视图名字转核心库名字
     * @param name
     * @return {*}
     */
    viewNameToCoreName: function (name) {
      return _animationMap[name];
    },

    /**
     * @description 核心库名字转视图名字
     * @param name
     * @return {string}
     */
    coreNameToViewName: function (name) {
      let __viewName = '';
      for (let key in _animationMap) {
        if (_animationMap.hasOwnProperty(key) && _animationMap[key] === name) {
          __viewName = key;
        }
      }

      return __viewName;
    }
  }
})();